import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsToggle1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSettingsToggle1"><Path fillRule="evenodd" clipRule="evenodd" d="M1 12C1 8.13401 4.13401 5 8 5H16C19.866 5 23 8.13401 23 12C23 15.866 19.866 19 16 19H8C4.13401 19 1 15.866 1 12ZM12.375 12C12.375 9.99797 13.998 8.375 16 8.375C18.002 8.375 19.625 9.99797 19.625 12C19.625 14.002 18.002 15.625 16 15.625C13.998 15.625 12.375 14.002 12.375 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSettingsToggle1;
